import Accordion from "react-bootstrap/Accordion";

export const FAQ = () => {
  // Import assets dynamically to avoid module resolution issues
  const applicationDocx = new URL("./assets/application.docx", import.meta.url).href;
  const applicationPdf = new URL("./assets/application.pdf", import.meta.url).href;
  return (
    <div>
      <Accordion className="faq" defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Q: What is the mission of your animal rescue organization? </Accordion.Header>
          <Accordion.Body>
            Our mission is to rescue, rehabilitate, and rehome animals in need, with a focus on those who have been
            neglected, mistreated, or abandoned. We believe all animals deserve to be treated with love and respect, and
            we strive to provide them with the care and support they need to thrive.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Q: How can I adopt an animal from your organization? </Accordion.Header>
          <Accordion.Body>
            To adopt an animal from our organization, you will need to fill out an adoption application and undergo an
            adoption interview with one of our staff members. This process helps us ensure that we are placing our
            animals in the best possible homes. We also require all adopters to sign an adoption contract agreeing to
            provide proper care for the animal.
            <br />
            <br />
            You can download and fill out an application here: <a href={applicationDocx}>DOCX</a> |{" "}
            <a href={applicationPdf}>PDF</a>. Once we receive your application, a member of our team will be in touch
            with you to discuss the next steps in the adoption process.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>Q: Can I foster an animal from your organization? </Accordion.Header>
          <Accordion.Body>
            Yes, we have a foster program that allows individuals or families to temporarily care for an animal in their
            own home. Fostering is a great way to help an animal transition to a new home, and it also frees up space in
            our rescue so we can help more animals in need. If you are interested in fostering, please fill out a foster
            application and a member of our team will be in touch with you to discuss the program in more detail..
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>Q: How can I donate to your organization? </Accordion.Header>
          <Accordion.Body>
            There are several ways to donate to our organization. You can make a one-time donation online through our
            website, or you can set up a recurring donation to make a bigger impact over time. You can also donate goods
            or services that we can use to care for the animals in our rescue, such as food, toys, or medical supplies.
            If you have something specific in mind, please contact us and we will be happy to discuss it with you.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header>Q: How can I volunteer with your organization? </Accordion.Header>
          <Accordion.Body>
            We are always looking for dedicated volunteers to help us care for the animals in our rescue. There are many
            ways to get involved, including helping with animal care and feeding, assisting with adoption events and
            fundraising efforts, and more. If you are interested in volunteering, please fill out a volunteer
            application and a member of our team will be in touch with you to discuss opportunities.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="5">
          <Accordion.Header>
            Q: How can I stay updated on the latest news and events from your organization?{" "}
          </Accordion.Header>
          <Accordion.Body>
            To stay updated on the latest news and events from our organization, you can follow us on social media, sign
            up for our email newsletter, or check out our website regularly. We also encourage you to follow us on
            social media to see the latest updates on the animals in our rescue and learn about upcoming events and
            fundraising efforts.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
